import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { ResponseModel } from '../../_models/response.model';
import { UserRegisterModel } from '../../_models/user-register.model';
import { SecretWordModel } from '../../_models/secret-word.model';
import { UserDataModel } from '@modules/auth';

const API_USERS_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(
    private http: HttpClient,
  ) {
  }

  login(email: string, password: string): Observable<ResponseModel<UserDataModel>> {
    return this.http.post<ResponseModel<UserDataModel>>(`${API_USERS_URL}/Account/authenticate`, {email, password});
  }

  checkSecretWord(email: string, word: string): Observable<ResponseModel<boolean>> {
    return this.http.post<ResponseModel<boolean>>(`${API_USERS_URL}/Account/check-secret-word`, {email, word});
  }

  checkNickname(params: {userName: string}): Observable<ResponseModel<boolean>> {
    return this.http.post<ResponseModel<boolean>>(`${API_USERS_URL}/Account/check-username-available`, params);
  }

  createUser(user: UserRegisterModel): Observable<ResponseModel<UserDataModel>> {
    return this.http.post<ResponseModel<UserDataModel>>(`${API_USERS_URL}/Account/register`, user);
  }

  forgotPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${API_USERS_URL}/Account/forgot-password`, {email});
  }

  getUserByToken(jwToken): Observable<ResponseModel<UserDataModel>> {
    const headers = new HttpHeaders({Authorization: `Bearer ${jwToken}`});
    return this.http.get<ResponseModel<UserDataModel>>(`${API_USERS_URL}/Account/authenticate`, {headers}).pipe(
      shareReplay({bufferSize: 1, refCount: true})
    );
  }

  updateSecretWord(word: string): Observable<ResponseModel<number>> {
    return this.http.post<ResponseModel<number>>(`${API_USERS_URL}/v1/SecretWord`, {word});
  }

  getSecretWord(): Observable<ResponseModel<SecretWordModel>> {
    return this.http.get<ResponseModel<SecretWordModel>>(`${API_USERS_URL}/v1/SecretWord`);
  }

  resetPassword(email: string, token: string, password: string, confirmPassword: string): Observable<ResponseModel<string>> {
    return this.http.post<ResponseModel<string>>(`${API_USERS_URL}/Account/reset-password`, {email, token, password, confirmPassword});
  }

  confirmEmail({code, userId}: { code: any; userId: any }) {
    return this.http.get(`${API_USERS_URL}/Account/confirm-email`, {params: {code, userId}});
  }
}
